<template>
    <div class="dialog-form">
        <div class="open-wrapper pointer" @click="openModal">
            <slot>
                <a href="javascript://void(0)" class="btn btn-sm btn-warning">
                    <i class="fa fa-trash-o" aria-hidden="true"></i>
                </a>
            </slot>
        </div>

        <modal :name=modalId
               :adaptive="true"
               :scrollable="true"
               height="auto">
            <div class="dashboard-block" :class="{loading: loading}">
                <form method="POST" :action="action" accept-charset="UTF-8" novalidate="novalidate">
                    <input name="_method" type="hidden" :value="method">
                    <input name="_token" type="hidden" :value="token">

                    <slot name="header">
                        <header>
                            <h4>Are you sure?</h4>
                        </header>

                        <a href="javascript://void(0)" class="back" @click="closeModal">Close</a>
                    </slot>

                    <slot name="body">
                    </slot>

                    <hr>

                    <slot name="footer">
                        <div class="row">
                            <div class="col-xs-5 col-md-7">
                                <a type="submit" class="btn btn-default" @click="closeModal">
                                    Cancel
                                </a>
                            </div>

                            <div class="col-xs-7 col-md-5">
                                <button type="submit" class="btn btn-success btn-block">
                                    Confirm
                                </button>
                            </div>
                        </div>
                    </slot>
                </form>
            </div>
        </modal>
    </div>
</template>

<script>
    export default {
        props: {
            action: {
                required: true,
                type: String
            },

            method: {
                required: true,
                type: String
            },

            modalId: {
                default: Math.random().toString(),
                type: String
            },
        },

        created: function(){
            this.init();
        },

        data: function(){
            return {
                loading: false,
                token: null
            };
        },

        methods: {
            /** Instance Functions **/
            init: function(){
                this.token = $( 'meta[name="csrf-token"]' ).attr( 'content' );
            },

            openModal: function(){
                this.$modal.show( this.modalId );
            },

            closeModal: function(){
                this.$modal.hide( this.modalId );
            },
        }
    }
</script>
